const joinPhrase = (term) => term.replace(/\s+/g, '_');
const splitPhrase = (term) => term.replace(/_+/g, ' ');
const removeOperators = (term) => term.replace(/(^\+|^-|^"|"$)/g, '');
export function queryTerms(query) {
    return query
        .replace(/"[^"]+"/g, joinPhrase)
        .split(/\s/)
        .map((term) => [
        removeOperators(splitPhrase(term)).toLowerCase(),
        term.startsWith('"')
            ? 'phrase'
            : term.startsWith('+')
                ? 'require'
                : term.startsWith('-')
                    ? 'exclude'
                    : 'include',
    ])
        .filter(([term]) => term.length);
}
//# sourceMappingURL=query.js.map